module.exports = __webpack_public_path__ + "img/entertainment-2.630901a9.jpg";